import { render, staticRenderFns } from "./MediaModal.vue?vue&type=template&id=8e7f827e&scoped=true&"
import script from "./MediaModal.vue?vue&type=script&lang=js&"
export * from "./MediaModal.vue?vue&type=script&lang=js&"
import style0 from "./MediaModal.vue?vue&type=style&index=0&id=8e7f827e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7f827e",
  null
  
)

export default component.exports